var map = {
	"./img/brush-icon.png": 20,
	"./img/bucket-icon.png": 21,
	"./img/close-icon-sw.png": 22,
	"./img/close-icon.png": 23,
	"./img/drop-selection-icon.png": 24,
	"./img/eraser-icon.png": 25,
	"./img/pencil-icon.png": 26,
	"./img/undo-icon-sw.png": 27,
	"./sounds/donkerblauw.mp3": 28,
	"./sounds/emmer.mp3": 29,
	"./sounds/geel.mp3": 30,
	"./sounds/groen.mp3": 31,
	"./sounds/kwast.mp3": 32,
	"./sounds/lichtblauw.mp3": 33,
	"./sounds/oranje.mp3": 34,
	"./sounds/paars.mp3": 35,
	"./sounds/potlood.mp3": 36,
	"./sounds/rood.mp3": 37,
	"./sounds/roze.mp3": 38
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 135;


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared ^\.\/.*$
// module id = 135
// module chunks = 0